import { fetchProductInstances } from "@futuri/cloudsso-client/src/client/admin";
import { CachedInstances } from ".";
import { groupKeysBy, notUndefined } from "@futuri/cloudsso-client/src/util";
import {
  createCompanyInstance,
  createClusterInstance
} from "@futuri/cloudsso-client/src/instanceUtils";
import { POST } from "@futuri/cloudsso-client/src/client/types/productType";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";

export const setSelectedStation = async (
  { commit }: { commit: any },
  id: string
) => {
  console.log("setting edit user email: ", id);
  commit("SET_SELECTED_STATION", id);
};

export const setSelectedBinding = async (
  { commit }: { commit: any },
  instanceId?: string
) => {
  console.log("setting edit user email: ", instanceId);
  commit("SET_SELECTED_BINDING", instanceId);
};
export const clearSelectedBinding = async ({ dispatch }: { dispatch: any }) => {
  dispatch("setSelectedBinding", undefined);
};

export const fetchInstances = async (
  {
    getters,
    rootGetters,
    commit
  }: { getters: any; rootGetters: any; commit: any },
  id: string
) => {
  const companyName = getters.currentCompany;
  const filters = {
    companyName
  };

  const { baseUrl } = rootGetters;
  const stationInstances = await fetchProductInstances(baseUrl, POST, filters);
  const companyInstance = createCompanyInstance(POST, companyName);

  const getCluster = (inst?: ProductInstanceResult) =>
    inst?.criteria?.filter(c => c.key === "region")[0]?.value ?? "";
  const clusterNames = groupKeysBy(stationInstances ?? [], getCluster);

  const clusterInstances = clusterNames?.map(clusterName =>
    createClusterInstance(POST, companyName, clusterName)
  );

  const instances = [companyInstance]
    .concat(clusterInstances)
    .concat(stationInstances ?? [])
    .filter(notUndefined);

  const cached: CachedInstances = {
    companyName,
    instances
  };
  console.log(`setting cached instances (company: ${companyName}): `, cached);
  commit("SET_CACHED_INSTANCES", cached);
};
